var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0499 14.0501C14.2984 13.8016 14.7013 13.8016 14.9498 14.0501L17.8135 16.9138C18.062 17.1623 18.062 17.5652 17.8135 17.8137C17.565 18.0622 17.162 18.0622 16.9135 17.8137L14.0499 14.9501C13.8014 14.7016 13.8014 14.2986 14.0499 14.0501Z",
    fill: "#8790A1",
    stroke: "#8790A1",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.3636C4 6.8491 6.8491 4 10.3636 4C13.8782 4 16.7273 6.8491 16.7273 10.3636C16.7273 13.8782 13.8782 16.7273 10.3636 16.7273C6.8491 16.7273 4 13.8782 4 10.3636ZM10.3636 5.27273C7.55201 5.27273 5.27273 7.55201 5.27273 10.3636C5.27273 13.1753 7.55201 15.4546 10.3636 15.4546C13.1753 15.4546 15.4546 13.1753 15.4546 10.3636C15.4546 7.55201 13.1753 5.27273 10.3636 5.27273Z",
    fill: "#8790A1",
    stroke: "#8790A1",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.655533a977f0b35e7bf3694c66be94a6.svg";
export { ForwardRef as ReactComponent };